import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "./axiosBaseQuery";

const baseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://localhost:7123/api/v1";

export const api = createApi({
  reducerPath: "api",
  baseQuery: axiosBaseQuery({ baseUrl }),
  tagTypes: [
    "CollectorAllocation",
    "CollectorPerformance",
    "CustomerFeedback",
    "Dashboard",
    "AdminCatalog",
    "Roles",
    "Designations",
    "Users",
    "Employees",
    "HrDepartments",
    "HrDesignations",
    "HrHolidays",
    "HrDeductions",
    "HrTax",
    "MasterCustomers",
    "CustomerQrLabels",
    "OneStopReport",
    "MasterCustomerLinks",
    "MasterCustomerBranchMap",
    "MasterProducts",
    "MasterProductLinks",
    "MasterProductGroups",
    "MasterProductBranchMap",
    "MasterEmployees",
    "EmployeeDocuments",
    "Feedback",
    "Settings",
    "Vehicles",
    "VehicleRequests",
    "FuelCards",
    "FuelLinks",
    "FuelVehicles",
    "FuelRefills",
    "FuelTransactions",
    "StockLpo",
    "StockLpoRevisions",
    "StockIn",
    "StockOut",
    "StockReturn",
    "StockAdjustment",
    "StockBalance",
    "PettyCashFund",
    "PettyCashCategory",
    "PettyCashVoucher",
    "PettyCashVoucherReturn",
    "PettyCashRefill",
    "PettyCashReconciliation",
    "PettyCashLedger",
    "SalesEnquiry",
    "SalesOrder",
    "SalesClientVisit",
    "GuardServiceType",
    "AmcEquipment",
    "AmcContract",
    "AmcSchedule",
    "QuotationPrototype",
    "Quotation",
    "MasterTechnicalChecklistItems",
    "TechnicalWork",
    "TechnicalWorkActivity",
    "TechnicalPendingAssignment",
    "TechnicalDutyList",
    "AlarmResponses",
    "MobileUnits",
    "GuardingSupervisorAreas",
    "AttendanceStandingPosts",
    "QuickMenu",
    "Notification",
  ],
  endpoints: () => ({}),
});
